module.exports = __webpack_public_path__ + "static/media/Cyberbullying Essentials Script FINAL_031423_1678800021184.2e678291.docx";